import { render, staticRenderFns } from "./MilestoneForm.vue?vue&type=template&id=15259d5a&scoped=true"
import script from "./MilestoneForm.vue?vue&type=script&lang=js"
export * from "./MilestoneForm.vue?vue&type=script&lang=js"
import style0 from "./MilestoneForm.vue?vue&type=style&index=0&id=15259d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15259d5a",
  null
  
)

export default component.exports